import React from 'react'
import styles from './Subscription.module.css'
import Avatar from '@material-ui/core/Avatar'
import { Typography } from '@material-ui/core'
import cx from 'classnames'

const Subscription = () => {
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <Avatar
          alt='Music Icon'
          src={require('../../images/icon-music.svg').default}
          className={cx(styles.avatar, styles.subElement)}
        />
        <div className={cx(styles.subInfo, styles.subElement)}>
          <Typography
            variant='body2'
            component='p'
            className={styles.subTitle1}
          >
            Annual Plan
          </Typography>
          <Typography variant='body2' component='p' color='textSecondary'>
            $59.99/year
          </Typography>
        </div>
      </div>
      <div>
        <a href='#' className={styles.buttonChange}>
          Change
        </a>
      </div>
    </div>
  )
}

export default Subscription
